import { FeatureConfig } from './types'

export const vilmers: FeatureConfig = {
  impersonation: {
    storefront: true,
    b2bPortal: true,
  },
}
